"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var UsersApi = /** @class */ (function () {
    function UsersApi(axios) {
        var _this = this;
        // admin
        this.getAllUsers = function () { return _this.instance.get('/api/users/all'); };
        // regular
        this.getMe = function () { return _this.instance.get("/api/me"); };
        this.getMyAccountHistory = function () { return _this.instance.get("/api/me/history"); };
        this.getAccountHistory = function (id) { return _this.instance.get("/api/user/" + id + "/history"); };
        this.getUsers = function (schoolId) { return _this.instance.get("/api/users/" + schoolId); };
        this.getCheckedIn = function (schoolId, date, includeStudents, includeStaff) {
            if (includeStudents === void 0) { includeStudents = true; }
            if (includeStaff === void 0) { includeStaff = false; }
            return _this.instance.post("/api/users/checkedin/" + schoolId, {
                date: date,
                includeStudents: includeStudents,
                includeStaff: includeStaff,
            });
        };
        this.getCheckedInLog = function (schoolId, date, staffMemberIDs, includeStudents, includeStaff) {
            if (includeStudents === void 0) { includeStudents = true; }
            if (includeStaff === void 0) { includeStaff = false; }
            return _this.instance.post("/api/users/checkedin/" + schoolId + "/log", {
                date: date,
                staffMemberIDs: staffMemberIDs,
                includeStudents: includeStudents,
                includeStaff: includeStaff,
            });
        };
        this.getCheckedInToday = function (schoolId) { return _this.instance.get("/api/users/checkedin/" + schoolId); };
        this.getHealthyUsers = function (schoolId) { return _this.instance.get("/api/users/healthy/" + schoolId); };
        this.getInactiveUsers = function (schoolId) { return _this.instance.get("/api/users/inactive/" + schoolId); };
        this.getMonitoredUsers = function (schoolId) { return _this.instance.get("/api/users/monitored/" + schoolId); };
        this.getNeedsReviewUsers = function (schoolId) { return _this.instance.get("/api/users/review/" + schoolId); };
        this.getNotRespondedTodayUsers = function (schoolId) {
            return _this.instance.get("/api/users/not-responded/" + schoolId);
        };
        this.getQuarantinedUsers = function (schoolId) { return _this.instance.get("/api/users/quarantined/" + schoolId); };
        this.getRespondedTodayUsers = function (schoolId) { return _this.instance.get("/api/users/responded/" + schoolId); };
        this.getUnknownUsers = function (schoolId) { return _this.instance.get("/api/users/unknown/" + schoolId); };
        this.getInactiveStaff = function (schoolId) { return _this.instance.get("/api/users/staff/inactive/" + schoolId); };
        this.getStaff = function (schoolId) { return _this.instance.get("/api/users/staff/" + schoolId); };
        this.getHealthyStaff = function (schoolId) { return _this.instance.get("/api/users/staff/healthy/" + schoolId); };
        this.getPendingStaff = function (schoolId) { return _this.instance.get("/api/users/staff/pending/" + schoolId); };
        this.getQuarantinedStaff = function (schoolId) {
            return _this.instance.get("/api/users/staff/quarantined/" + schoolId);
        };
        this.getIsolatedStaff = function (schoolId) { return _this.instance.get("/api/users/staff/isolated/" + schoolId); };
        this.getUnknownStaff = function (schoolId) { return _this.instance.get("/api/users/staff/unknown/" + schoolId); };
        this.getUser = function (id) { return _this.instance.get("/api/user/" + id); };
        this.getUserForCheckin = function (id) { return _this.instance.get("/api/userForCheckin/" + id); };
        this.getStaffForCheckin = function (id) { return _this.instance.get("/api/staffForCheckin/" + id); };
        this.getUserClasses = function (id) { return _this.instance.get("/api/user/" + id + "/classes"); };
        this.createUser = function (values) { return _this.instance.post("/api/user/", __assign({}, values)); };
        this.deleteUser = function (id) { return _this.instance.delete("/api/user/" + id); };
        this.addNote = function (id, values) {
            return _this.instance.post("/api/user/" + id + "/add-note", __assign({}, values));
        };
        this.updateNote = function (id, noteId, values) {
            return _this.instance.post("/api/user/" + id + "/update-note/" + noteId, __assign({}, values));
        };
        this.deleteNote = function (id, noteId) { return _this.instance.post("/user/" + id + "/delete-note/" + noteId); };
        this.clearUser = function (id, monitored, quarantined) {
            return _this.instance.post("/api/user/" + id + "/clear", {
                monitored: monitored,
                quarantined: quarantined,
            });
        };
        this.monitorUser = function (id, startDate, endDate) {
            return _this.instance.post("/api/user/" + id + "/monitor", {
                start: startDate,
                end: endDate,
            });
        };
        this.quarantineUser = function (id, startDate, endDate) {
            return _this.instance.post("/api/user/" + id + "/quarantine", {
                start: startDate,
                end: endDate,
            });
        };
        this.updateHomeSchool = function (id, school) {
            return _this.instance.post("/api/user/" + id + "/homeSchool", {
                school: school,
            });
        };
        this.updatePreferences = function (id, preferences) {
            return _this.instance.post("/api/user/" + id + "/preferences", {
                preferences: preferences,
            });
        };
        this.updateUser = function (id, district, role, schools, isTechAdmin) {
            return _this.instance.post("/api/user/" + id, {
                district: district,
                schools: schools,
                role: role,
                isTechAdmin: isTechAdmin,
            });
        };
        this.updateRole = function (id, role) {
            return _this.instance.post("/api/user/" + id + "/role", {
                role: role,
            });
        };
        this.instance = axios;
    }
    return UsersApi;
}());
exports.default = UsersApi;
